import { Dialog, DialogContent } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppData } from '../../../../../../context/AppDataContext';
import { useAlert } from '../../../../../../context/AlertContext';

import proposalItemService from '../proposalItemServices';
import SelectProduct from '../../../finance/product/components/SelectProduct';


function ProposalItemFrom({ proposalDetails, productList, callBack }) {
    
    const { AppAlert } = useAlert();

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [item, setItem] = useState(null);
    const [errorList, setErrorList] = useState([]);

    // When a product is picked from the Autocomplete
    useEffect(() => {
        if (selectedProduct) {
            let _item ={}; //{ ...selectedProduct };
            
            _item['productId'] = selectedProduct.id;
            _item['title'] = selectedProduct.title;
            _item['hsn'] = selectedProduct.hsn;
            _item['details'] = selectedProduct.details;

            _item['cost'] = selectedProduct.cost || 0; 
            _item['price'] = selectedProduct.price || 0; 
            _item['mrp'] = selectedProduct.mrp || 0; 

            _item['gstRate'] = selectedProduct.gstRate || 0;

            _item['uom'] = selectedProduct.uom;
            _item['qty'] = 1; 
            _item['remark'] = "";


            const cost = selectedProduct.cost || 0;
            const price = selectedProduct.price || 0;

            // Formula: ((Price - Cost) / Cost) * 100
            _item['profitPercent'] = cost > 0 ? parseFloat((((price - cost) / cost) * 100).toFixed(2)) : 0;
            
            setItem(_item);
            //setSelectedProduct(null);
        }
    }, [selectedProduct]);

    const handleItemChange = (key, value) => {
        setItem({ ...item, [key]: value });
    };


    
    const addItem = () => {
        const payload = {
            ...item,
            proposalId: proposalDetails.id,
            amount: Number(item.price*item.qty)
        };
        

        console.log(payload);
        
        proposalItemService.save(payload).then(res => {
            AppAlert(res.msg);
            callBack(); 
            setItem(null); 
            setSelectedProduct(null);
        }).catch(err => {
            AppAlert(err.msg || "Error adding item", "error");
        });
        
    };

    const handleDiscountChange = (type, val) => {
        const cost = Number(selectedProduct?.cost || 0);
        let updatedPrice = Number(item.price || 0);
        let updatedProfitPct = Number(item.profitPercent || 0);

        if (type === "price") {
            updatedPrice = Number(val);
            // Recalculate profit percentage based on new price
            updatedProfitPct = cost > 0 ? (((updatedPrice - cost) / cost) * 100) : 0;
        } else if (type === "pct") {
            updatedProfitPct = Number(val);
            // Recalculate selling price based on new profit percentage
            // Formula: Cost + (Cost * (Percentage / 100))
            updatedPrice = cost + (cost * (updatedProfitPct / 100));
        }

        setItem({
            ...item,
            price: parseFloat(updatedPrice.toFixed(2)),
            profitPercent: parseFloat(updatedProfitPct.toFixed(2))
        });
    };


    return (
        <>
            <SelectProduct 
                options={productList} 
                selectedProduct={selectedProduct} 
                setSelectedProduct={setSelectedProduct} 
            />

            <Dialog open={item !== null} onClose={() => {setItem(null); setSelectedProduct(null)}} fullWidth maxWidth="md">
                <DialogContent>
                    {item && (
                        <div className="p-2">
                            {/* --- INPUT FORM SECTION --- */}
                            <table className='table table-borderless align-middle mb-4'>
                                <tbody>
                                    <tr>
                                        <th style={{ width: '30%' }}>Product</th>
                                        <td>
                                                <input 
                                                    className='form-control form-control-lg fw-semibold' 
                                                    type='text' 
                                                    value={item.title} 
                                                    onChange={(e) => handleItemChange("title", e.target.value)} 
                                                />
                                        </td>
                                    </tr>

                                    <tr>
                                        <th style={{ width: '30%' }}>Details</th>
                                        <td>
                                                <textarea
                                                    className='form-control ' 
                                                    value={item.details} 
                                                    onChange={(e) => handleItemChange("details", e.target.value)} 
                                                    rows={5}
                                                    cols={40}
                                                />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light fw-bold">Cost</span>
                                                <span className="input-group-text bg-white">{selectedProduct.cost}</span>
                                                <span className="input-group-text bg-light fw-bold">Selling Price</span>
                                                <span className="input-group-text bg-white">{selectedProduct.price}</span>
                                                <span className="input-group-text bg-light fw-bold">MRP</span>
                                                <span className="input-group-text bg-white">{selectedProduct.mrp}</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Price</th>
                                        <td>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light fw-bold">₹</span>
                                                <input 
                                                    className='form-control form-control-lg fw-semibold' 
                                                    type='number' 
                                                    value={item.price} 
                                                    onChange={(e) => handleDiscountChange("price", e.target.value)} 
                                                    placeholder="0.00"
                                                />
                                                <span className="input-group-text bg-light text-secondary small">Profit %</span>
                                                <input 
                                                    className='form-control text-success fw-semibold' 
                                                    type='number' 
                                                    value={item.profitPercent} 
                                                    onChange={(e) => handleDiscountChange("pct", e.target.value)}
                                                    placeholder="%"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>GST %</th>
                                        <td>
                                            <div className="input-group" style={{ maxWidth: '200px' }}>
                                                <input className='form-control' type='number' value={item.gstRate} 
                                                    onChange={(e) => handleItemChange("gstRate", e.target.value)} />
                                                <span className="input-group-text">%</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Quantity</th>
                                        <td>
                                            <input className='form-control' type='number' value={item.qty} 
                                                onChange={(e) => handleItemChange("qty", e.target.value)} style={{ maxWidth: '200px' }} />
                                        </td>
                                    </tr>


                                    <tr>
                                        <th style={{ width: '30%' }}>Remark</th>
                                        <td>
                                                <textarea
                                                    className='form-control ' 
                                                    value={item.remark} 
                                                    onChange={(e) => handleItemChange("remark", e.target.value)} 
                                                    rows={5}
                                                    cols={40}
                                                />
                                        </td>
                                    </tr>
                                    
                                </tbody>
                            </table>

                            

                            {/* --- ERROR MESSAGE & ACTION BUTTONS BAR --- */}
                            <div className="d-flex justify-content-between align-items-center pt-2 border-top">
                                <div className="flex-grow-1 me-3">
                                    {errorList.map((err, i) => (
                                        <div key={i} className='text-danger small fw-semibold'>• {err}</div>
                                    ))}
                                </div>
                                <button className='btn btn-success btn-lg px-4 fw-bold shadow-sm' onClick={addItem}>
                                    Add Item
                                </button>
                            </div>
                        </div>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
}

export default ProposalItemFrom;